import { MessageBox } from 'element-ui'

const MARKER_ID = 'login-expired-messagebox-marker'
let currentPromise = null

function isMarkerPresent() {
  return !!document.getElementById(MARKER_ID)
}

function ensureMarker() {
  if (isMarkerPresent()) return
  const el = document.createElement('div')
  el.id = MARKER_ID
  el.style.display = 'none'
  document.body.appendChild(el)
}

function removeMarker() {
  const el = document.getElementById(MARKER_ID)
  if (el && el.parentNode) el.parentNode.removeChild(el)
}

/**
 * 职责唯一：提示“登录过期”，点击“退出”后刷新页面。
 *
 * 这里通过在 body 插入隐藏 marker 的方式保证同一时刻只打开一个
 */
export function openExpireDialog(options = {}) {
  if (isMarkerPresent()) return currentPromise || Promise.resolve()
  if (currentPromise) return currentPromise

  ensureMarker()
  const message = `
   您的登录已过期，或账号在其他设备登录。请重新登录以继续使用。
  `

  const p = MessageBox.confirm(message, {
    title: options.title || '账号下线通知',
    confirmButtonText: options.confirmButtonText || '重新登录',
    dangerouslyUseHTMLString: true,
    showCancelButton: false,
    showClose: false,
    closeOnClickModal: false,
    closeOnPressEscape: false,
    ...(options.boxOptions || {})
  })
    .then(() => {
      window.location.href = '/oauth/logout'
    })
    .finally(() => {
      currentPromise = null
      removeMarker()
    })

  currentPromise = p
  return p
}
